import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const Tabs: FunctionComponent<Props> = ({ children, className = '', testId = TEST_ID }) => (
    <div className={`${className} ${styles.tabs}`} data-testid={testId} role="tablist">
        {children}
    </div>
);

export default Tabs;
